import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/site/Header";
import Footer from "./components/site/Footer";
import { Toaster } from "./components/ui/sonner";
import { trackPageView } from "./lib/analytics";
import { captureAttributionOnce } from "./lib/attribution";

import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import MarketNotes from "./pages/MarketNotes";
import MarketNote from "./pages/MarketNote";
import Diagnostic from "./pages/Diagnostic";

function ScrollHandler() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname, location.hash]);
  return null;
}

const PAGE_TITLES = {
  "/": "HuddleUp — Your commercial arm in Saudi Arabia",
  "/services": "Services — HuddleUp",
  "/about": "About — HuddleUp",
  "/market-notes": "Market Notes — HuddleUp",
  "/diagnostic": "Saudi Entry Diagnostic — HuddleUp",
};

function TitleHandler() {
  const location = useLocation();
  useEffect(() => {
    // Defensive override — the platform script rewrites document.title on load.
    const base = "HuddleUp — Your commercial arm in Saudi Arabia";
    const match = PAGE_TITLES[location.pathname];
    if (match) {
      document.title = match;
    } else if (location.pathname.startsWith("/market-notes/")) {
      document.title = "Market Note — HuddleUp";
    } else {
      document.title = base;
    }
    // Fire SPA page_view after the title has been set so GA4 records the
    // correct page_title for each route.
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <Header />
      <main className="flex-1 pt-[72px]">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  useEffect(() => {
    captureAttributionOnce();
  }, []);
  return (
    <BrowserRouter>
      <ScrollHandler />
      <TitleHandler />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/market-notes" element={<MarketNotes />} />
          <Route path="/market-notes/:slug" element={<MarketNote />} />
          <Route path="/diagnostic" element={<Diagnostic />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0F2A24",
            color: "#F5F0E6",
            border: "1px solid rgba(201,169,97,0.4)",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
